<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="administrator"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item v-if="isAdministrator" label="所属门店" prop="store_id">
        <v-select-store class="w100" v-model="administrator.store_id" :has-private="true"/>
      </el-form-item>

      <el-form-item label="职位" prop="administrator_role_id">
        <v-select-administrator-role class="w100" v-model="administrator.administrator_role_id"/>
      </el-form-item>

      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="administrator.username"
          placeholder="请输入登录用户名"
          minlength="3"
          maxlength="17"
          show-word-limit
          clearable
        />
        <el-alert
            title="3 ~ 17 位，字母或数字或符号，不含空格"
            type="warning"
            show-icon
            :closable="false"
            class="form-input-tip form-input"
        />
      </el-form-item>
      <el-form-item label="密码" prop="user_password">
        <el-input
          v-model="administrator.user_password"
          placeholder="请输入登录密码"
          minlength="8"
          maxlength="16"
          show-word-limit
          clearable
        />
        <el-alert
          title="8 ~ 16 位，至少含字母、数字、符号的任意两种，不含空格"
          type="warning"
          show-icon
          :closable="false"
          class="form-input-tip form-input"
        />
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="administrator.nickname"
          placeholder="请输入昵称"
          maxlength="14"
          show-word-limit
          clearable
        />
        <el-alert
            title="2 ~ 14 位的任意字符"
            type="warning"
            show-icon
            :closable="false"
            class="form-input-tip form-input"
        />
      </el-form-item>

      <v-image-upload
        v-model="administrator.avatar"
        label="头像"
        prefix="administrator"
        ratio="1:1"
        prop-name="avatar"
      />

      <v-input-administrator-phone v-model="administrator.phone"/>
      <el-form-item label="企业微信号">
        <el-input
          v-model="administrator.we_chat"
          placeholder="请输入企业微信号"
          minlength="2"
          maxlength="32"
          show-word-limit
          clearable
        />
      </el-form-item>

      <el-form-item label="底薪">
        <v-input-money class="w100" :max="99999.99" v-model="administrator.base_pay"/>
      </el-form-item>
      <el-form-item label="公司社保">
        <v-input-money class="w100" :max="99999.99" v-model="administrator.social_insurance"/>
      </el-form-item>
      <el-form-item label="门店社保">
        <v-input-money class="w100" :max="99999.99" v-model="administrator.store_insurance"/>
      </el-form-item>

      <el-form-item label="个人社保">
        <v-input-money class="w100" :max="99999.99" v-model="administrator.personal_insurance"/>
      </el-form-item>

      <el-form-item label="业绩任务">
        <v-input-money class="w100" :max="999999.99" v-model="administrator.task_income"/>
      </el-form-item>
      <el-form-item label="未完成底薪比例">
        <v-input-money class="w100" v-model="administrator.base_pay_rate"/>
      </el-form-item>
      <el-form-item label="完成后提成比例">
        <v-input-money class="w100" v-model="administrator.commission_rate"/>
      </el-form-item>

<!--      <el-form-item label="2021学生祝福语">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入2021年学生想对管理员说的祝福语"
          v-model="administrator.blessing"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.administratorList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { store } from '@/api/administrator';
import { toCent } from '@/filters';

export default {
  name: RouteConfig.administratorAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    administrator: {
      store_id: 0,
      administrator_role_id: 0,
      username: '',
      user_password: '',
      phone: '',
      nickname: '',
      avatar: '',
      we_chat: '',
      store_insurance: 0,


      base_pay: 0,
      social_insurance: 0,
      personal_insurance: 0,
      task_income: 0,
      base_pay_rate: 0,
      commission_rate: 0,

      blessing: '',
    },
    rules: {
      store_id: [{ required: true, message: '请选择所属门店', trigger: 'change' }],
      administrator_role_id: [{ required: true, message: '请选择职位', trigger: 'change' }],
      username: [{ required: true, message: '请输入登录用户名', trigger: 'change' }],
      user_password: [{ required: true, message: '请输入登录密码', trigger: 'change' }],
      nickname: [{ required: true, message: '请输入昵称', trigger: 'change' }],
      avatar: [{ required: true, message: '请上传真人自拍', trigger: 'change' }],
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.administrator };
        postData.base_pay = toCent(postData.base_pay);
        postData.social_insurance = toCent(postData.social_insurance);
        postData.store_insurance = toCent(postData.store_insurance);

        postData.personal_insurance = toCent(postData.personal_insurance);
        postData.task_income = toCent(postData.task_income);
        postData.base_pay_rate = toCent(postData.base_pay_rate);
        postData.commission_rate = toCent(postData.commission_rate);
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.administratorList.push();
      });
    },
  },
};
</script>
